
import { useEffect, useRef } from 'react';
import { useAnalytics } from './useAnalytics';
import { FormData } from '@/types/onboarding';

export const useOnboardingTracking = () => {
  const { 
    trackOnboardingStepComplete, 
    trackOnboardingComplete, 
    trackOnboardingAbandon,
    trackLeadGeneration 
  } = useAnalytics();
  
  const startTime = useRef<number>(Date.now());
  const currentStep = useRef<number>(0);

  useEffect(() => {
    startTime.current = Date.now();

    // Track abandonment when user leaves
    const handleBeforeUnload = () => {
      const timeSpent = Math.round((Date.now() - startTime.current) / 1000);
      trackOnboardingAbandon(currentStep.current, timeSpent);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [trackOnboardingAbandon]);

  const trackStepComplete = (stepNumber: number, stepName: string, userResponse?: string) => {
    currentStep.current = stepNumber;
    trackOnboardingStepComplete(stepNumber, stepName, userResponse);
    
    // Track email capture specifically
    if (stepNumber === 0 && userResponse?.includes('@')) {
      trackLeadGeneration(userResponse, 'onboarding_form');
    }
  };

  const trackOnboardingFinish = (formData: FormData) => {
    const completionTime = Math.round((Date.now() - startTime.current) / 1000);
    trackOnboardingComplete(completionTime, formData);
  };

  return {
    trackStepComplete,
    trackOnboardingFinish,
    getCurrentStep: () => currentStep.current,
    getTimeSpent: () => Math.round((Date.now() - startTime.current) / 1000)
  };
};
